import React from "react";
import "./MessageModal.css";

const MessageModal = ({ isVisible, title = "", message = "", type = "error", closeLabel = "Close", onClose }) => {
  if (!isVisible) return null;

  return (
    <div className="feedback-modal-overlay" role="alert" aria-live="assertive">
      <div className={`feedback-modal-box ${type}`}>
        {title ? <div className={`feedback-modal-title ${type}`}>{title}</div> : null}
        {message ? <div className="feedback-modal-text">{message}</div> : null}
        <button className="feedback-modal-close" onClick={onClose} type="button">
          {closeLabel}
        </button>
      </div>
    </div>
  );
};

export default MessageModal;
